import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

export const StorageChangeDialog = ({ storage, open, handleClose, handleSubmit }) => {
    return (
        <ModalDialogWrapper
            footerActions={
                storage.name === 'Опти' ? (
                    <>
                        <Button variant="outlined" fullWidth onClick={handleSubmit}>
                            Сменить
                        </Button>
                        <Button variant="contained" onClick={handleClose} fullWidth>
                            Остаться на «Макси»
                        </Button>
                    </>
                ) : (
                    <>
                        <Button variant="outlined" fullWidth onClick={handleClose}>
                            Отменить
                        </Button>
                        <Button variant="contained" onClick={handleSubmit} fullWidth>
                            Сменить
                        </Button>
                    </>
                )
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={`Сменить пакет на «${storage.name}» (${storage.storage_gb} ГБ)?`}>
            {storage.name === 'Опти' ? (
                <Typography variant="body2">
                    {`Сейчас активен пакет «Макси». Переход на «Опти» произойдёт после окончания оплаченного периода`}
                </Typography>
            ) : (
                <Typography variant="body2">
                    {`Новый пакет вступит в силу сразу. С вашего баланса будет списано ${storage.price_coins} коинов`}
                </Typography>
            )}
        </ModalDialogWrapper>
    )
}
